import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  Slide,
  IconButton,
  ClickAwayListener,
  InputBase,
  Button,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Tabs,
  Tab,
  Box,
  Modal,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Pagination,
  CircularProgress,

  Skeleton
} from '@mui/material';

import dayjs from 'dayjs';
import { styled } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Iconify from '../components/iconify';
import { Api, UploadFile } from "../webservices";
// import { common } from "@mui/material/colors";
import countries from './countryJson/countryJson.json';
import CustomComplete from '../components/customComplete/CustomComplete';
import CustomCompleteWorksheet from '../components/customComplete/CustomCompleteWorksheet';

const ActiveJobsList = () => {
  const [jobs, setJobs] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(35);
  const [totalCount, setTotalCount] = useState(0);
  const[id,setId]=useState('');

  const [loading, setLoading] = useState("");
  const [jobId1, setJobId] = useState(null);
  const [companyid, setCompanyId] = useState(null);
  const navigate = useNavigate();

  const [parse, setParse] = useState(false);
  const [fileInputFiles, setFileInputFiles] = useState([]);
  const parseOpen = () => setParse(true);
  const parseClose = () => setParse(false);

  const [circle, setCircle] = useState(false);
  const circleFn = () => {
    setCircle(true)
  }
  const circleFn1 = () => {
    setCircle(false)
  }
  useEffect(() => {
    getSkills()
  }, [])

  const totalPages = Math.ceil(totalCount / limit);

  const formatDateTime = (dateString) => {
    const d = new Date(dateString);
    const options = {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    };
    return d.toLocaleString("en-US", options).replace(",", "");
  };

  const tablebg = "rgba(82, 130, 190, 0.08)";

  const fetchJobs = async () => {
    setLoading("Loading...");

    try {
      const body = { page: page.toString(), limit: limit.toString() };
      const res = await Api(`company/activeJobsList`, "POST", body);

      if (res?.data?.data.length > 0) {
        setJobs(res.data.data);
        setTotalCount(res.data.count);
        // toast.success(res.data.message);
      }
      else {
        setLoading("No data found");
        setJobs([]);
        setTotalCount("");
      }

    } catch (err) {
      console.error("API Error:", err);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, [page]);

  const PaginationButton = ({ label, onClick, active, disabled }) => (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        padding: "6px 14px",
        margin: "0 4px",
        borderRadius: "6px",
        border: active ? "1px solid #3C6BA5" : "1px solid #ccc",
        background: active ? "rgba(82, 130, 190, 0.15)" : "#fff",
        cursor: disabled ? "not-allowed" : "pointer",
        color: active ? "#3C6BA5" : "#3C6BA5",
        fontWeight: active ? "700" : "500",
        fontSize: "14px",
        minWidth: "35px",
      }}
    >
      {label}
    </button>
  );

  const uploadMulti = (pdf) => {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('document', pdf);
      formData.append('directoryName', 'resume');

      UploadFile(`resume/upload_resume`, formData, token)
        .then((Response) => {
          if (Response.status === 200 && Response.data.code === 200) {
            ParseRes(Response.data.filePath);
            parseClose();
            circleFn();
            resolve(Response.data.filePath);
          } else {
            reject(Response.data.message || "Upload failed");
          }
        })
        .catch((err) => reject(err));
    });
  };

  const handleFileSelect = async (e) => {
    const files = e.target.files;
    const fileList = Array.from(files);

    parseClose();
    circleFn();

    setFileInputFiles(fileList);

    try {
      await Promise.all(fileList?.map(async (file) => { await uploadMulti(file) }));
    } catch (err) {
      console.error(err);
      toast.error("Some uploads failed!");
    }

  };

  const handleDrop = async (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    const fileList = Array.from(files);
    // console.log('files drop', fileList)

    setFileInputFiles(fileList);
    // fileList.map((item) => uploadMulti(item))

    try {
      await Promise.all(fileList?.map(async (file) => { await uploadMulti(file) }));
      // console.log("All resumes uploaded & parsed.");
    } catch (err) {
      console.error(err);
      toast.error("Some uploads failed!");
    }

  };

  //   const ParseRes = (parseres) => {

  //     const body = {
  //       "resumeUrl": parseres
  //     }
  //     const token = localStorage.getItem("token")
  //     Api('common/cv/data', 'POST', body, token).then((Response) => {

  //   //    console.log("print responce ==>", Response);
  //       // console.log("Response", Response)
  //       if (Response.status === 200) {

  //         Api("common/applyForJob", 'POST',{
  //           jobId: jobId1, resumeId: Response.data.result
  // ._id

  //         }, token).then((res)=>{
  //                     console.log("sumit sharma ",  res);
  //         })

  //       }
  //       else {
  //         console.log("shyamlal", Response);
  //       }
  //     })

  //   }

  const [tempskill, setTempskill] = useState([]);
  // const [skill, setSkill] = useState([{ title: 'zashi' }]);
  const [addedSkill, setAddedSkill] = useState([])

  const getSkills = async () => {
    const token = localStorage.getItem('token');
    Api(`resume/get_skills/${"other"}`, 'GET', '', token)
      .then((response) => {
        // console.log('=========getSkills======>>>>>>>', response.data);
        if (response.data.code === 200) {
          if (response.data.result.length !== 0) {
            response.data.result.map((item) => {
              return tempskill.push({ title: item.skillName });
            });

            setAddedSkill(tempskill)
            // console.log('===value skilll========', JSON.stringify(skill));
          } else {
            // setSkill([{ title: '' }]);
          }
        } else {
          toast.warn(response.data.message, +'!');
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const ParseRes = (parseres) => {
    const body = {
      resumeUrl: parseres,
      jobId:id
    };

    const token = localStorage.getItem("token");

    Api("common/cv/data", "POST", body, token)
      .then((Response) => {
        if (Response?.status === 200) {
          // const resumeId11 = Response?.data?.result?._id;

          // if (!resumeId11) {
          //   console.log("Resume ID missing:", Response);
          //   return;
          // }
          console.log("hello email",Response);
       //   applyJob(Response?.data?.result)



          //  navigate('/applyJobPreview', {
          //     state: {
          //       addedSkill,
          //       // cityStateStyling,
          //       row: id,
          //       Id: {
          //         jobId: jobId1,
          //         resumeId: id._id,

          //       }
          //     },
          //   });
          navigate('/applyJobPreview', {
            state: {
              addedSkill,
              // cityStateStyling,
              row: Response.data.result,
              Id:{
                jobId: jobId1,
                "companyid":companyid,
                resumeId: Response?.data?.result?._id,

              }
            },
          });

          // ----------------------------
          // SECOND API: applyForJob
          // ----------------------------
          // Api(
          //   "common/applyForJob",
          //   "POST",
          //   {
          //     jobId: jobId1,
          //     resumeId: resumeId11,
          //   },
          //   token
          // )
          //   .then((res) => {
          //     if (res?.status === 200) {
          //       toast.success(res.data.message);

          //       //  console.log(" Job Apply Successfully:", res);
          //     } else {
          //       //   console.log(" Apply Job ELSE ERROR:", res);
          //       toast.error(res.data.message);
          //     }
          //   })
          //   .catch((err) => {
          //     console.log("Apply Job CATCH Error:", err);
          //   });

        } else {
          console.log(" CV Parse ELSE ERROR:", Response);
        }
      })
      .catch((error) => {
        console.log("CV Parse CATCH Error:", error);
      });
  };

  const [pages, setPages] = useState(null);
  const [searchResult, setSearchResult] = React.useState();

  const searchDataFun = (data, count, totalPage) => {
    // console.log("data--------------", data)
    setJobs(null)
    setSearchResult(count)
    setPages(totalPage)
    setJobs(data)

  }

  const resetDataFun = () => {
    fetchJobs()
  }



  // const applyJob = async (id) => {
  //   const token = localStorage.getItem('token');
  //   const body = {
  //     jobId: jobId1,
  //     resumeId: id?._id,
  //     email: id?.email
  //   };
  //   Api(`common/applyForJob`, 'POST', body, token)
  //     .then((response) => {

  //       console.log("[]]==>>", response.data);
  //       // console.log('==========res=====>>>', response);
  //           if (response.status === 200) {
                  

  //         if (response.data.message === "You have already applied for this job.") {
  //          // console.log("hello")
  //                toast.warn(response.data.message);
  //         } else {
  //           navigate('/applyJobPreview', {
  //             state: {
  //               addedSkill,
  //               // cityStateStyling,
  //               row: id,
  //               Id: {
  //                 jobId: jobId1,
  //                 resumeId: id._id,

  //               }
  //             },
  //           });
  //         }




  //         //  toast.success(response?.data?.message);
  //         // if (response.data.code === 200) {
  //         //   toast.success(response?.data?.message);

  //         //   navigate('/applyJobPreview', {
  //         //     state: {
  //         //       addedSkill,
  //         //       // cityStateStyling,
  //         //       row: id,
  //         //       Id: {
  //         //         jobId: jobId1,
  //         //         resumeId: id._id,

  //         //       }
  //         //     },
  //         //   });


  //         // } else {
  //         //   toast.error(response.data.message);
  //         // }
  //       }
  //     })
  //     .catch((err) => { });
  // };




  return (
    <>
      <ToastContainer />

      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: '100%', px: 2, mt: 3 }}
      >

        <Search searchData={searchDataFun} func={resetDataFun} resetSearch={() => setSearchResult('')} />

        <Link to="/">
          <img
            alt="Logo"
            src="/assets/logoBlue.svg"
            style={{ height: 50, width: 'auto' }}
          />
        </Link>
      </Stack>

      <Typography variant="h5" color="textSecondary" sx={{ px: 2, py: 1.5 }} >
        Open Jobs
      </Typography>















      <Box sx={{ px: 2 }} >
        <TableContainer component={Paper} >
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead >
              <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '13.5%' }}>Date</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '15%' }}>Role</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '14.5%' }}>Compensation</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '14%' }}>Job Info</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '14%' }}>Applications</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {jobs && jobs?.map((item, index) => (
                <TableRow
                  key={index}
                  sx={[
                    { background: index % 2 === 0 ? 'text.background' : tablebg },
                    { '&:last-child td, &:last-child th': { border: 0 } },
                    { '&:hover': { boxShadow: 5 } },
                  ]}
                >
                  <TableCell sx={{}}>
                    <Typography>
                      Up - {formatDateTime(item.updatedAt)}
                    </Typography>

                    {/* {"\n"} */}
                    <Typography>

                      Cr - {formatDateTime(item.createdAT)}
                    </Typography>
                    <Typography>-</Typography>
                  </TableCell>





                  <TableCell>
                    <Typography

                      sx={{
                        fontWeight: '600', fontSize: '0.90rem', cursor: 'pointer', maxWidth: 200,
                        overflow: 'hidden', textOverflow: 'ellipsis',
                        color: "#286ACC"
                      }}
                      onClick={() => navigate('/jobDetails', { state: { row: item } })}
                    >

                      {item.jobTitle || "-"}

                    </Typography>






                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography sx={{ maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.companyName || '-'}
                      </Typography>

                      {/* {item.endClientOrImpPartner && (
                          
                                        <Iconify
                                          icon="mdi:web"
                                          color="text.secondary"
                                          sx={{ ml: 0.5, height: 15, width: 15, cursor: 'pointer' }}
                                          onClick={() => window.open(item.website, '_blank', 'noopener', 'noreferrer')}
                                        />
                                      )} */}
                    </Box>











                    {/*                    
                        <Typography>
                          {item.endClientOrImpPartner || "-"}
                        </Typography> */}



                    <Stack sx={{ flexDirection: 'row', gap: 0.5 }}>
                      <Typography sx={{ fontWeight: '600', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }} color={'#286ACC'}>
                        {/* {row.location || '-'} */}
                        {item.city || '-'}, {item.stateCode || ''}
                      </Typography>

                      {item.outOfAreaCandidate === "Yes" && (
                        <Iconify icon="mdi:aeroplane" fontSize={20} color={'text.secondary'} />
                      )}
                    </Stack>

                  </TableCell>









                  {/* 
                      <TableCell>
                        {item.compensationType === "annual" && (
                          <Typography>
                            ${item.annualMinCompensation}K - $
                            {item.annualMaxCompensation}K
                          </Typography>
                        )}

                        {item.compensationType === "per hour" && (
                          <Typography>
                            {item.payRateOn?.minPayRate} P/H -{" "}
                            {item.payRateOn?.maxPayRate} P/H
                          </Typography>
                        )}

                        <Stack sx={{ flexDirection: "row", gap: 0.5 }}>
                          {item.taxTerm?.length
                            ? item.taxTerm.map((val, i) => (
                              <Typography key={i}>
                                {val} {i < item.taxTerm.length - 1 && "|"}
                              </Typography>
                            ))
                            : "-"}
                        </Stack>

                        <Typography sx={{ color: "text.textG" }}>
                          {item.remote || "-"}
                        </Typography>
                      </TableCell> */}





                  <TableCell sx={{}}>
                    {item.compensationType === 'annual' ? (
                      <Typography sx={{}} >
                        {/* {row?.country ===  "INDIA" ? "₹" :"$"} */}

                        {item.country === "INDIA" ? "₹" : item.country === "UK" ? "£" : "$"}

                        {item.annualMinCompensation} K{' - '}
                        {/* {row?.country ===  "INDIA" ? "₹" :"$"} */}
                        {item.country === "INDIA" ? "₹" : item.country === "UK" ? "£" : "$"}

                        {item.annualMaxCompensation} K
                      </Typography>
                    ) : null}

                    {item.compensationType === 'per hour' ? (
                      // <Typography sx={{ textTransform: 'none' }} >
                      //   ${row.payRateOn.minPayRate} P/H{' - '}
                      //   ${row.payRateOn.maxPayRate} P/H
                      // </Typography>

                      <Typography sx={{ textTransform: 'none' }}>
                        {item.payRateOn?.minPayRate || item.payRateOn?.maxPayRate ? (
                          // {row.payRateOn?.minPayRate && row.payRateOn?.maxPayRate ? (
                          `${item.payRateOn?.minPayRate} P/H - $${item.payRateOn?.maxPayRate} P/H`
                        ) : (
                          `$${item.onC2c1099Inc?.minC2c1099Inc} P/H - $${item.onC2c1099Inc?.maxC2c1099Inc} P/H`
                        )}
                      </Typography>

                    ) : null}

                    <Stack sx={{ flexDirection: 'row', gap: 0.5, maxWidth: 130, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {item.taxTerm.length ? item.taxTerm.map((item1, index) => {
                        return <Typography key={index} sx={{ textTransform: 'none' }}>{item1} {index < item.taxTerm.length - 1 && '|'}</Typography>
                      }) :
                        <Typography sx={{ flexDirection: 'row' }}>-</Typography>}
                    </Stack>

                    {/* <Typography sx={{ flexDirection: 'row', color: 'text.textG' }}>{row.duration || '-'}</Typography> */}
                    <Typography sx={{ flexDirection: 'row', color: 'text.textG' }}>{item.remote || '-'}</Typography>
                  </TableCell>


















                  {/* 
                      <TableCell>
                        <Typography sx={{ fontWeight: 600 }}>
                          {item.jobId}
                        </Typography>
                        <Typography>{item.jobType}</Typography>
                        <Typography sx={{ color: "text.textG" }}>
                          {item.openings}{" "}
                          {item.openings === "1" ? "opening" : "openings"}
                        </Typography>
                      </TableCell> */}






                  <TableCell sx={{}}>
                    <Typography sx={{ flexDirection: 'row', color: 'text.secondary', fontWeight: '600' }}>{item.jobId || '-'}</Typography>
                    <Typography sx={{ flexDirection: 'row' }}>{item.jobType || '-'}</Typography>
                    {item.openings === '1' ? (
                      <Typography sx={{ flexDirection: 'row', color: 'text.textG' }}>{item.openings} opening</Typography>
                    ) : (
                      <Typography sx={{ flexDirection: 'row', color: 'text.textG' }}>{item.openings} openings</Typography>
                    )}
                  </TableCell>











                  <TableCell>
                    <Typography>
                      Applied : {item.appliedCount ? item.appliedCount : 0}
                    </Typography>

                    <Typography>
                      Shortlisted : {item.shortlistCount ? item.shortlistCount : 0}
                    </Typography>

                    <Typography>
                      Unqualified : {item.rejectCount ? item.rejectCount : 0}
                    </Typography>

                  </TableCell>

                  <TableCell>
                    <Button
                      //  sx={{ width: 120 }}
                      sx={{ px: 6 }}
                      // fullWidth
                      variant="contained"
                      size="small"
                      color="custom"
                      // sx={{ background: "#3C6BA5" }}
                      onClick={() => {
                        parseOpen();
                        setJobId(item.jobId);
                        setId(item._id);
                        setCompanyId(item.companyID)
                      }}
                    >
                      Apply
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

      </Box>

























      {loading === "Loading..." ? (
        <Stack>
          {Array.from({ length: searchResult?.length || 10 })?.map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              sx={{
                height: 80,
                width: '100%',
                backgroundColor: index % 2 === 0 ? 'text.background' : tablebg,
              }}
            />
          ))}
        </Stack>

      ) :
        <Stack sx={{ mt: 2, p: 2 }}>
          <Typography sx={{ alignSelf: 'center', color: 'red' }}>
            {loading}

          </Typography>
        </Stack>
      }


      {searchResult?.length > 35 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: 15,
            paddingRight: 10,
          }}
        >
          <PaginationButton
            label="<"
            onClick={() => page > 1 && setPage(page - 1)}
            disabled={page <= 1}
          />

          {[...Array(totalPages)].map((_, i) => (
            <PaginationButton
              key={i}
              label={i + 1}
              onClick={() => setPage(i + 1)}
              active={page === i + 1}
            />
          ))}

          <PaginationButton
            label=">"
            onClick={() => page < totalPages && setPage(page + 1)}
            disabled={page >= totalPages}
          />
        </div>
      ) :
        (
          null
        )

      }



      {/* </Paper> */}




















      <Modal open={parse} onClose={parseClose}>

        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: {
              xs: '90%',
              sm: '70%',
              md: '50%',
              lg: '30%',
            },
            backgroundColor: 'white',
            border: '4px solid #1E74B3',
            borderRadius: '13px',
            p: 2,
            outline: 'none',
            maxHeight: '90vh',
            overflowY: 'auto',
          }}
        >

          <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
            <Box
              sx={{
                border: '3px dashed #1E74B3',
                p: 2,
                borderRadius: '15px',
                my: 2,
                textAlign: 'center',
                color: '#1E74B3',
              }}
            >
              <Typography variant="body1" fontWeight="bold" mb={1}>
                Browse File
              </Typography>
              <input
                id="file-upload"
                type="file"
                accept=".doc,.docx,application/pdf"
                onChange={handleFileSelect}
                style={{ display: 'none' }}
                multiple
              />
            </Box>
          </label>

          <Typography
            variant="body1"
            fontWeight="bold"
            mb={1}
            sx={{
              textAlign: 'center',
              color: '#1E74B3',
            }}
          >
            OR
          </Typography>

          <Box
            sx={{
              border: '3px solid #1E74B3',
              p: 2,
              borderRadius: '15px',
              my: 2,
              textAlign: 'center',
              height: '200px',
              color: '#1E74B3',
            }}
            onDrop={handleDrop}
            onDragOver={(e) => e.preventDefault()}
          >
            Drag & Drop to Upload File
          </Box>

          {fileInputFiles?.length > 0 && (
            <Box sx={{ px: 2 }}>
              {fileInputFiles?.map((file, index) => (
                <Typography key={index} variant="body2">
                  {file.name}
                </Typography>
              ))}
            </Box>
          )}

          {/* <label htmlFor="file-upload-excel" style={{ cursor: 'pointer' }}>
                  <Box
                    sx={{
                      border: '3px dashed #1E74B3',
                      p: 2,
                      borderRadius: '15px',
                      my: 2,
                      textAlign: 'center',
                      color: '#1E74B3',
                    }}
                  >
                    <Typography variant="body1" fontWeight="bold" mb={1}>
                      Browse Excel File
                    </Typography>
                    <input
                      id="file-upload-excel"
                      type="file"
                      accept=".csv,.xlsx"
                      onChange={handleFileSelectExcel}
                      style={{ display: 'none' }}
                      multiple
                    />
                  </Box>
                </label>
      
                {inputExcel?.length > 0 && (
                  <Box sx={{ px: 2 }}>
                    {inputExcel?.map((file, index) => (
                      <Typography key={index} variant="body2">
                        {file.name}
                      </Typography>
                    ))}
                  </Box>
                )}
      
                <Typography
                  color="custom"
                  variant="body2"
                  sx={{ textAlign: 'center', mt: 2 }}
                >
                  <a
                    href="/assets/Parsing-Candidate.xlsx"
                    download
                    style={{
                      textDecoration: 'underline',
                      color: '#1E74B3',
                    }}
                  >
                    Download Excel Format
                  </a>
                </Typography> */}
        </Box>
      </Modal>
    </>
  );
};

export default ActiveJobsList;















function Search({ searchData, func, resetSearch }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [latt, setLatt] = useState('')
  const [long, setLong] = useState('')
  const [valuee, setValue] = useState(localStorage.getItem("country"));
  const [cityData, setCityData] = useState([]);
  const [cityQuery, setCityQuery] = useState("");
  const [cityAndState, setCityAndState] = useState(null);
  const [stateCode, setStateCode] = useState('')

  const [formValues, setFormValues] = useState({
    commonSearch: "",
  });

  const [Values, setValues] = useState({
    commonSearch: "",

    status: "",
    fromDate: "",
    tillDate: "",
    jobType: "",

  });

  const [loadingData, setLoadingData] = useState('')
  const [loading, setLoading] = useState('')
  const CommonSearcFun = (page = 1) => {
    searchData('')
    // searchData([])
    setLoading(true);
    setLoadingData('Loading...')
    const body = {
      "commonSearch": Values.commonSearch,
      "status": Values.status,
      "fromDate": Values.fromDate,
      "tillDate": Values.tillDate,
      "remote": Values.jobType,
      "jobType": Values.jobTime,
      "page": page,
      "city": cityQuery,
      // "state": stateQuery,
      ...(stateQuery && !cityQuery ? { "state": stateQuery } : {}),
      "stateCode": stateCode || stateId,
      "country": valuee,
      "limit": "50"
    }

    const token = localStorage.getItem('token');
    Api('common/searchActiveJobsFullAccess', 'POST', body, token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            // searchData(response.data.data)
            if (response.data.data && response.data.data.length > 0) {
              // searchData(response.data.data);
              const totalPage = Math.ceil(response.data?.count / 35)
              searchData(response.data.data, response.data.count, totalPage)
              setLoadingData('');
              setLoading(false);
            } else {
              searchData([]);
            }
          } else {
            // console.log('Error:', response.data.message);
          }
        }
      })
      .catch((error) => {
        // console.error("Error:", error);
      });
  };

  const [loading1, setLoading1] = useState(false);

  const fn = (page = 1) => {
    searchData('')
    setLoading1(true)
    const body = {
      "commonSearch": formValues.commonSearch,
      "page": page,
      "limit": "50"
    }
    const token = localStorage.getItem('token');
    Api('common/searchActiveJobsFullAccess', 'POST', body, token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            // searchData(response.data.data)
            const totalPage = Math.ceil(response.data.count / 35)
            searchData(response.data.data, response.data.count, totalPage)

            setLoading1(false)
          } else {
            // console.log('Error:', response.data.message);
          }
        }
      })
      .catch((error) => {
        // console.error("Error:", error);
      });
  };

  const [isVisible, setIsVisible] = useState(true);

  const toggleVisibility = () => {
    setValue(localStorage.getItem("country"))
    resetSearch()
    clearInputField()
    setIsVisible(!isVisible);
    func()
    setFormValues({ ...formValues, commonSearch: '' });
    setCityQuery('')
    setStateQuery('')
  };

  const [searchOpen, setSearchOpen] = useState(false);

  const handleSearchOpen = () => {
    setSearchOpen(true);
  };

  const handleSearchClose = () => {
    setSearchOpen(false);
  };

  const handleDateChange = (date, field) => {
    const formattedDate = dayjs(date).format('YYYY-MM-DDTHH:mm:ss[Z]');
    setValues((prevRec) => ({
      ...prevRec,
      [field]: formattedDate
    }));
    // console.log("formattedDate====>>>>", formattedDate);
  };

  const clearInputField = () => {
    setValues({
      ...Values,
      commonSearch: '',

      status: "",
      fromDate: "",
      tillDate: "",
      jobType: "",
      jobTime: '',

    });
    setCityQuery('')
    setStateQuery('')

    setStateCode('')
    setValue(localStorage.getItem("country"))

  }

  const [err, setErr] = useState(false);
  const [helperText, setHelperText] = useState('');
  const getCity = async (val) => {
    setHelperText('')
    setErr(false)
    const token = localStorage.getItem('token');
    const body = {
      country: valuee || localStorage.getItem("country"),
      query: val,
    };
    try {
      const response = await Api('resume/get_city_states', 'POST', body, token);
      if (response.status === 200 && response.data.code === 200) {
        setCityData(response.data.data || []);

      } else {
        // console.error(response.data.message);
        setHelperText("No cities found for the given city name.")
        setErr(true)
        // toast.error(response.data.message)
        setCityData([]);
      }
    } catch (err) {
      console.error(err);
      setCityData([]);
    }

  };
  // const [cityy, setCityy]= useState()

  const childFuc = (val) => {
    setCityData([])
    // console.log("vall===", val)
    if (typeof (val) === "string") {
      // console.log("val", val)
      // alert("USA")
      if (val.length >= 3) {
        getCity(val);
      }

      setCityQuery(val);
      // handleCityChange(val);
    }
    else {
      // alert("CAN") 
      if (val.city.length >= 3) {
        getCity(val.city);
      }
      setStateQuery(val?.state)
      setCityQuery(val?.city);
      // handleCityChange(val.city);
      setLatt(val?.lat);
      setLong(val?.lng);
      setStateCode(val?.stateCode || val?.postal)
    }

  };

  const [stateData, setStateData] = useState([]);
  const [stateQuery, setStateQuery] = useState("");
  const [stateId, setStateId] = useState("");
  const [selectedState, setSelectedState] = useState(null);

  const handleStateChange = async (val) => {

    setStateQuery(val?.state_name || val?.province_or_StateName);
    setStateId(val?.state_id || val?.province_id)

    if (val.length >= 3) {
      await getState(val);
    }
  };

  const getState = async (val) => {
    const token = localStorage.getItem('token');
    const body = {
      country: valuee,
      stateName: val,
    };
    try {
      const response = await Api('resume/get_states', 'POST', body, token);
      if (response.status === 200 && response.data.code === 200) {
        setStateData(response.data.data || []);

      } else {
        console.error(response.data.message);
        setStateData([]);
      }
    } catch (err) {
      console.error(err);
      setStateData([]);
    }
  };

  const childFucState = async (val) => {
    // console.log("stateval", val)
    setStateQuery(val?.state_name || val?.province_or_StateName);
    handleStateChange(val);

  };

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const [cityStateStyling, setCityStateStyling] = useState(true)

  return (
    <>
      <ClickAwayListener onClickAway={handleClose}>
        <div>

          <div style={{ display: "flex", alignItems: "flex-start" }}>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >

              <Paper
                component="form"
                sx={{
                  minWidth: "320px",
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #1E74B3",
                  borderRadius: "10px",
                }}
              >
                <InputBase
                  sx={{
                    flex: 1,
                    color: "text.primary",
                    border: "none",
                    outline: "none",
                    pl: 1,
                  }}
                  placeholder="Job Id | Job Title"
                  inputProps={{ "aria-label": "search" }}
                  value={formValues.commonSearch}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      commonSearch: e.target.value,
                    })
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      fn();

                    }
                  }}
                />
              </Paper>

              <div style={{ marginTop: "0.1px" }}>
                <IconButton onClick={handleSearchOpen}>
                  <Iconify icon="bxs:down-arrow" color="#1E74B3" />
                </IconButton>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "12px",
              }}
            >
              <Button
                color="custom"
                variant="contained"
                size="small"
                sx={{ ml: 1 }}
                onClick={() => {
                  fn();

                }}
                disabled={loading1}
              >
                {loading1 ? <CircularProgress size={24} /> : "Search"}
              </Button>

              {(formValues.commonSearch ||
                Values?.commonSearch ||

                Values?.status ||
                Values?.fromDate ||
                Values?.tillDate ||
                Values?.jobType ||
                Values?.jobTime ||
                cityQuery || stateQuery) && (
                  <Button
                    color="custom"
                    variant="contained"
                    size="small"
                    sx={{ ml: 1.6 }}
                    onClick={() => {
                      toggleVisibility();

                    }}
                  >
                    Close
                  </Button>
                )}
            </div>
          </div>
        </div>
      </ClickAwayListener>


      <Modal open={searchOpen} onClose={handleSearchClose}>

        <Box className="morFltr_pop" sx={{
          position: 'absolute',
          top: '36%',
          transform: 'translate(-60%, -50%)',
          width: { xs: '95%', sm: '70%' },
          // width: { xs: '85%', sm: '60%' },
          bgcolor: 'background.paper',
          border: '3px solid #3C6BA5',
          boxShadow: 24,
          p: 2,
          borderRadius: 3,
        }}
        >

          <Grid container spacing={1} justifyContent="center">
            <Grid item xs={12} >
              <TextField
                label="Job ID / Job Title"
                variant="outlined"
                fullWidth
                margin="dense"
                size="small"

                value={Values.commonSearch}
                onChange={(e) => setValues({ ...Values, commonSearch: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    CommonSearcFun();
                    handleSearchClose();
                    // funcc()
                  }
                }}
              />
            </Grid>

            <Grid container sx={{ flexDirection: "row", marginLeft: '1px' }} spacing={1}>
              <Grid item xs={6} sx={{ marginTop: "1.5px" }}>
                <FormControl fullWidth size="small">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="From"
                      slotProps={{ textField: { size: "small" } }}
                      value={Values.fromDate ? dayjs(Values.fromDate) : null}
                      // onChange={(date) => handleDateChange1(date, 'fromDate')}
                      onChange={(date) => handleDateChange(date, 'fromDate')}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={6} sx={{ marginTop: "1.5px" }}>
                <FormControl fullWidth size="small">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Till"
                      slotProps={{ textField: { size: "small" } }}
                      value={Values.tillDate ? dayjs(Values.tillDate) : null}
                      // onChange={(date) => handleDateChange1(date, 'tillDate')}
                      onChange={(date) => handleDateChange(date, 'tillDate')}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
            </Grid>

            <Grid item xs={6}>

              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Remote</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  // value={value.domain}
                  value={Values.jobType}
                  label="Job Type"
                  // InputLabelProps={{ shrink: true }}
                  onChange={(e) => setValues({ ...Values, jobType: e.target.value })}
                >

                  <MenuItem value={"onsite Job"}>Onsite</MenuItem>
                  <MenuItem value={"remote"}>Remote</MenuItem>
                  <MenuItem value={"hybrid"}>Hybrid</MenuItem>

                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Job Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Job Type"
                  placeholder="Job Type"
                  value={Values.jobTime}
                  onChange={(e) => setValues({ ...Values, jobTime: e.target.value })}
                >
                  <MenuItem value={'fulltime'}>Full Time</MenuItem>
                  <MenuItem value={'permanent'}>Permanent</MenuItem>
                  <MenuItem value={'contract'}>Contract</MenuItem>
                  <MenuItem value={'CTH'}>CTH</MenuItem>
                  <MenuItem value={'temporary'}>Temporary</MenuItem>
                  <MenuItem value={'internship'}>Internship</MenuItem>
                  <MenuItem value={'parttime'}>Part Time</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={4}>
              <FormControl variant="outlined" fullWidth size="small">
                <InputLabel>Select Country</InputLabel>
                <Select
                  value={valuee}
                  onChange={handleChange}
                  label="Select Country"
                >

                  {countries?.map((item) => (
                    <MenuItem key={item.id} value={item.country}>
                      {item.country}
                    </MenuItem>
                  ))}

                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={4} >
              <CustomCompleteWorksheet
                // <CustomComplete
                placeholder={'City'}
                size="small"
                option={cityData}
                propVal={cityQuery}
                childFuc={childFuc}
                fetch={'state'}
                cityStateStyling1={cityStateStyling}
                err={err}
                helperText={helperText}


              />

            </Grid>

            <Grid item xs={4} size="small">
              <CustomComplete
                placeholder={'State'}
                size="small"
                option={stateData}
                propVal={stateQuery}
                childFuc={childFucState}
                cityStateStyling1={cityStateStyling}
                err={err}
                helperText={helperText}

              />

              <FormControl fullWidth size="small">
                {selectedState ? (
                  <Stack sx={{ ml: 1, mb: 2, mt: -1, flexDirection: 'row' }}>
                    <Typography color="text.secondary" variant="body1">
                      {/* {selectedState.state_name} */}
                    </Typography>
                  </Stack>
                ) : null}
              </FormControl>
            </Grid>

            <Grid item xs={6} textAlign="center" sx={{ marginTop: "1px" }}>
              <Button color="custom" variant="contained" size="small"

                onClick={() => { CommonSearcFun(); handleSearchClose() }}

              >
                Search
              </Button>
              <Button color="custom" variant="contained" size="small"
                sx={{ marginLeft: '12px' }}
                onClick={clearInputField}
              >
                Clear All
              </Button>
            </Grid>
          </Grid>

        </Box>
      </Modal>

    </>
  );
}

// function FoxearchLogo({ size = 32, color = "#3b5998" }) {
//   return (
//     <svg
//       width={size}
//       height={size}
//       viewBox="0 0 64 64"
//       fill="none"
//       stroke={color}
//       strokeWidth="3"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <path d="M8 12 L32 4 L56 12 L32 60 Z" />
//       <path d="M8 12 L24 32 L32 60" />
//       <path d="M56 12 L40 32 L32 60" />
//       <path d="M24 32 L32 24 L40 32" />
//     </svg>
//   );
// }